module.exports = __webpack_public_path__ + "media/country_flags/nc-e36f98df.png";